module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-cell vux-x-textarea"
  }, [_c('div', {
    staticClass: "weui-cell__hd"
  }, [(_vm.hasRestrictedLabel) ? _c('div', {
    style: (_vm.labelStyles)
  }, [_vm._t("restricted-label")], 2) : _vm._e(), _vm._v(" "), _vm._t("label", [(_vm.title) ? _c('label', {
    staticClass: "weui-label",
    class: _vm.labelClass,
    style: ({
      width: _vm.$parent.labelWidth || (_vm.labelWidth + 'em'),
      textAlign: _vm.$parent.labelAlign,
      marginRight: _vm.$parent.labelMarginRight
    }),
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.inlineDesc) ? _c('inline-desc', [_vm._v(_vm._s(_vm.inlineDesc))]) : _vm._e()])], 2), _vm._v(" "), _c('div', {
    staticClass: "weui-cell__bd"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentValue),
      expression: "currentValue"
    }],
    ref: "textarea",
    staticClass: "weui-textarea",
    style: (_vm.textareaStyle),
    attrs: {
      "autocomplete": _vm.autocomplete,
      "autocapitalize": _vm.autocapitalize,
      "autocorrect": _vm.autocorrect,
      "spellcheck": _vm.spellcheck,
      "placeholder": _vm.placeholder,
      "readonly": _vm.readonly,
      "name": _vm.name,
      "rows": _vm.rows,
      "cols": _vm.cols,
      "maxlength": _vm.max
    },
    domProps: {
      "value": (_vm.currentValue)
    },
    on: {
      "focus": function($event) {
        _vm.$emit('on-focus')
      },
      "blur": function($event) {
        _vm.$emit('on-blur')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.currentValue = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showCounter && _vm.max),
      expression: "showCounter && max"
    }],
    staticClass: "weui-textarea-counter",
    on: {
      "click": _vm.focus
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.count))]), _vm._v("/" + _vm._s(_vm.max) + "\n    ")])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6582acec", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6582acec"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vux/src/components/x-textarea/index.vue
// module id = 271
// module chunks = 18